import { useTranslation } from "react-i18next";

import money from "astrid-helpers/src/money";

import useDistributionPriceTypeTranslations from "../../distribution/hooks/useDistributionPriceTypeTranslations";

export default function useArticleChannelMetadata() {
	const { t } = useTranslation();

	const priceTypeTranslations = useDistributionPriceTypeTranslations();

	return [
		{
			name: "prices",
			label: t("prices", "Prices"),
			format: (data) =>
				data.prices
					?.map((price) => `${money(price.amount, price.currency)} (${priceTypeTranslations[price.type]})`)
					.join(", "),
		},
		{
			name: "countries",
			label: t("countries", "Countries"),
			format: (data) => data.countries?.join(", "),
		},
		{
			name: "subChannels",
			label: t("subChannels", "Sub channels"),
			format: (data) => data.subChannels?.map((subChannel) => subChannel.name).join(", "),
		},
	];
}
